// export const API_PATH = "https://uniserved.classyserve.com/api/v1";
// export const API_PATH = "http://127.0.0.1:8000/api/v1";
// export const API_PATH = 'https://api.orion22.com/api/v1';            // partners.uniserved.com backend
// export const API_PATH = 'https://uniservedapi.orion22.com/api/v1';  //Matrix Backend
// export const API_PATH = "https://wanted-chigger-radically.ngrok-free.app/api/v1";     //local ser?ver
export const OPENFIRE_WSS_URL = "wss://chat.orion22.com:7443/ws/"; // For Secure Connection
export const OPENFIRE_WS_URL = "ws://chat.orion22.com:7070/ws/"; // For Insecure Connection
export const API_PATH = "https://stagingapi.orion22.com/api/v1"; //staging server
// export const API_PATH = "https://devapi.orion22.com/api/v1"; //dev server
// export const API_PATH = "https://9f88-202-166-184-2.ngrok-free.app/api/v1"; //staging server
//

